














































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Message } from 'element-ui';
import http from '../unite/http';
// @ts-ignore
import * as qs from 'querystring';
@Component({
  components: {}
})
export default class Dialog extends Vue {
  @Prop() optionTitle: any;
  @Prop() rules: any;
  @Prop() formList: any;
  @Prop() alert: any;
  @Prop() tip: any;
  info: any = { ...this.formList.form };
  loading: boolean = false;
  dialogVisible: boolean = true;
  city: any = [
    {
      value: 1,
      label: 'vcf2'
    },
    {
      value: 2,
      label: 'vcfw'
    },
    {
      value: 3,
      label: 'vcf3'
    },
    {
      value: 4,
      label: 'vcf4'
    },
    {
      value: 5,
      label: 'vcf5'
    }
  ];
  num: number = 0;
  numWidth: string = '50%';
  pickerOptions: any = {
    shortcuts: [
      {
        text: '今天',
        onClick(picker: any) {
          picker.$emit('pick', new Date());
        }
      },
      {
        text: '昨天',
        onClick(picker: any) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      },
      {
        text: '一周前',
        onClick(picker: any) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }
    ]
  };
  created() {
    //  console.log(this.formList)
  }
  // 确认
  confirm(formName: any) {
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        if (this.alert) {
          this.$confirm(
            `${this.tip.title}${this.info[this.tip.money]}, 是否继续?`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.sure();
            })
            .catch(() => {});
        } else {
          this.sure();
        }
      }
    });
  }
  sure() {
    this.loading = true;
    http
      .request({
        url: this.formList.url,
        method: 'post',
        data: qs.stringify(this.info)
      })
      .then(d => {
        this.loading = false;
        this.$emit('callback', this.info)
        this.$emit('refesh', true);
        Message({
          message: '操作成功',
          type: 'success',
          duration: 5 * 1000
        });
      })
      .catch(e => {
        this.loading = false;
      });
  }
  // 取消
  cancel() {
    this.$emit('callback', this.info)
    this.$emit('refesh', false);
  }
  handleCheckedCitiesChange() {
    console.log(this.info);
  }
  // 销毁清除定时器
  destroyed() {
    // this.formList.form = {}
    // clearInterval(this.timer)
  }
}
